import '../../css/frames.css'
import Logo from './Logo'

export default function Loading(){
    return <main className='loading-page'>
        <Logo size={350}/>
    </main>
}